import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'

const DynamicTypography = ({ text = '', ...props }) => {
  const parsedText = text.replace(/\{(\w+)\}/g, (_, key) => {
    return props[key] !== undefined ? props[key] : ''
  })

  return (
    <Typography {...props}>
      {parsedText}
    </Typography>
  )
}

DynamicTypography.propTypes = {
  text: PropTypes.string.isRequired,
  props: PropTypes.object,
}

export default DynamicTypography
